// extracted by mini-css-extract-plugin
export default {"portalContainer":"portal_portalContainer__Isarx","portal":"portal_portal__GNBoQ"};